module.exports = __webpack_public_path__ + "static/media/brewer-stage-logo-drawer.ba5cb3c7.png";